import { getProfitCalculation } from "@/services/pricing-config.service";
import { useQuery } from "@tanstack/react-query";

export const useAllProfitCalculation = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  return useQuery({
    queryKey: [
      "all-profit-calculation",
      params.page,
      params.size,
      params.search,
    ],
    queryFn: () => getProfitCalculation(params),
    enabled,
    ...options,
  });
};
